import { useCallback, useMemo, useState } from 'react';
import { TitleContext, TitleState } from './TitleContext';

export const TitleProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [titleState, setTitleState] = useState<TitleState>({
    firmOrCompanyName: '',
    pageName: '',
    measurementDate: '',
  });
  
  const updateTitle = useCallback((key: keyof TitleState, value: string) => {
    setTitleState(prev => ({ ...prev, [key]: value }));
  }, []);
  
  const updateMultiple = useCallback((updates: Partial<TitleState>) => {
    setTitleState(prev => ({ ...prev, ...updates }));
  }, []);
  
  const resetTitle = useCallback(() => {
    setTitleState({
      firmOrCompanyName: '',
      pageName: '',
      measurementDate: '',
    });
  }, []);
  
  const contextValue = useMemo(() => ({
    ...titleState,
    updateTitle,
    updateMultiple,
    resetTitle,
  }), [titleState, updateTitle, updateMultiple, resetTitle]);

  return (
    <TitleContext.Provider value={contextValue}>
      {children}
    </TitleContext.Provider>
  );
};
